// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="text-center space-ptb">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                        <h2 className="mb-4">{t('homePage.presentation.presentationTitle')}</h2>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text1') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text2') as string }}></p>
                    </div>
                    <div className="col-12 col-lg-6">
                        <img src="/assets/images/agenzia/esterno.jpg" className="img-fluid border-img" alt="Ceccarelli" />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;
